import { render } from "./AdminTest.vue?vue&type=template&id=9858be22&scoped=true"
import script from "./AdminTest.vue?vue&type=script&lang=js"
export * from "./AdminTest.vue?vue&type=script&lang=js"

import "./AdminTest.vue?vue&type=style&index=0&id=9858be22&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9858be22"]])

export default __exports__